import ExportModal from './ExportModal';
export default ExportModal;



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/components/ExportModal/index.ts